/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type PrintTransparentNobufferBlueishSvgIconProps =
  React.ComponentProps<"svg"> & {
    title?: string;
  };

export function PrintTransparentNobufferBlueishSvgIcon(
  props: PrintTransparentNobufferBlueishSvgIconProps
) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      xmlnsXlink={"http://www.w3.org/1999/xlink"}
      version={"1.1"}
      viewBox={"0 0 999.6 299.5"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <defs>
        <linearGradient
          id={"a"}
          x1={"801.1"}
          x2={"667.7"}
          y1={"1213.9"}
          y2={"1013.9"}
          gradientTransform={"rotate(-180 624.8 909)scale(1.5)"}
          gradientUnits={"userSpaceOnUse"}
        >
          <stop offset={".2"} stopColor={"#fff"}></stop>

          <stop offset={".4"} stopColor={"#01303f"}></stop>
        </linearGradient>
      </defs>

      <path
        fill={"url(#a)"}
        d={"M0 299.5h149.8v-7.3H7.3V7.3h284.9v142.5h7.3V0H0z"}
      ></path>

      <path
        fill={"#fff"}
        d={
          "M424.9 219.2h8.5v-31.5h8.5l15.1 31.5h9.1l-15.5-32.4c7.1-1.8 11.9-6.8 11.9-18.4v-14.5c0-16.2-9.1-19.4-20.6-19.4H425v84.7Zm8.5-38.8v-38.7h8.5c7.4 0 12.1 2.3 12.1 13.3v12.1c0 11-4.7 13.3-12.1 13.3zm79.5-46v84.7h36.3v-7.3h-27.8v-31.5H542V173h-20.6v-31.5H548v-7.3h-35.1Zm123.7 42.4h-21.8v7.3h13.3v14.5c0 11-4.7 13.3-12.1 13.3s-12.1-2.3-12.1-13.3V155c0-11 4.7-13.3 12.1-13.3s12.1 2.3 12.1 13.3v12.1h8.5v-14.5c0-16.2-9.1-19.4-20.6-19.4s-20.6 3.2-20.6 19.4V201c0 16.2 9.2 19.4 20.6 19.4s9.7-1.6 12.9-8.2l2.8 7h4.8v-42.4Zm52.3 42.4h8.5v-31.5h8.5l15.1 31.5h9.1l-15.5-32.4c7.1-1.8 11.9-6.8 11.9-18.4v-14.5c0-16.2-9.1-19.4-20.6-19.4H689v84.7Zm8.4-38.8v-38.7h8.5c7.4 0 12.1 2.3 12.1 13.3v12.1c0 11-4.7 13.3-12.1 13.3zm72.3 38.8h8.5l4.8-23h21.7l4.8 23h8.5l-17.8-84.7h-12.7zm14.9-30.3 9.3-44.4 9.3 44.4h-18.7Zm98.4-54.5h-18.2v84.7h18.2c11.5 0 20.6-3.4 20.6-19.4v-46c0-16.2-9.1-19.4-20.6-19.4Zm-9.7 7.3h9.7c7.4 0 12.1 2.3 12.1 13.3v43.6c0 11-4.7 13.3-12.1 13.3h-9.7zm82.5-7.3v84.7H992v-7.3h-27.8v-31.5h20.6V173h-20.6v-31.5h26.6v-7.3h-35.1Z"
        }
      ></path>

      <path
        fill={"#9df304"}
        d={
          "M130.9 201.2h9.4v-35h9.4l16.8 35h10.1l-17.2-36c7.9-2 13.2-7.5 13.2-20.4v-16.1c0-18-10.1-21.5-22.9-21.5h-18.8v94.1Zm9.4-43v-43h9.4c8.2 0 13.4 2.6 13.4 14.8v13.4c0 12.2-5.2 14.8-13.4 14.8z"
        }
      ></path>

      <path
        fill={"#7fd858"}
        d={
          "M999.6 187.3s-1.7 0-4.6-.2c-3.2 0-7.6-.2-13.2-.2-11.6-.2-27.9-.6-47.7-.8-9.9-.2-20.6-.2-31.7-.4-11.3 0-23.1-.2-35.5-.2s-25.2-.2-38-.2h-78.6c-13 0-25.6.2-38 .2-24.6.2-47.7.4-67.2.6-19.7.2-36.1.6-47.7.8-5.7 0-10.3.2-13.4.2-2.7.2-4.4.2-4.4.2s1.7 0 4.6.2c3.2 0 7.6.2 13.2.2 11.6.2 27.9.6 47.7.8 19.7.2 42.6.4 67.2.6 12.4 0 25 .2 38 .2h78.6c13 0 25.6-.2 38-.2s24.2-.2 35.5-.2c11.1-.2 21.8-.4 31.5-.4 19.7-.2 36.1-.6 47.7-.8 5.7 0 10.3-.2 13.2-.2 3.2-.2 4.8-.2 4.8-.2"
        }
        data-name={"Layer_1"}
      ></path>
    </svg>
  );
}

export default PrintTransparentNobufferBlueishSvgIcon;
/* prettier-ignore-end */
